import React from 'react'
import WhuImg from '../../../../../assets/img/diet_care.webp'

function DietCaresec2() {
  return (
    <section className='whu-sec'>
        <div className='container'>
            <div className='ffr-sec'>
                <div className='ffr-head'>
                    <h3>Why Choose </h3>
                    <h4>DIET CARE?</h4>
                </div>
                <div className='ffr-desc'>
                    <p>Are you trying to lose weight? Is your poor diet causing you health problems? Do you want to shift to eating healthier meals? Eat more nutritious food? Well, we’ve got you covered!</p>
                </div>
            </div>
            <div className='whu-sec1'>
                <div className='whulft'><img src={WhuImg} alt='Why Choose Diet Care' width={800} height={600} loading="lazy"/></div>
                <div className='whurgt'>
                    <p>Diet care is your little friend and we are going to walk you through a healthier lifestyle, guiding you by the hand. While there are quite a few options to choose from locally, what makes us stand out is our determination to ensure you get your healthy meal at your place of choice, at your fixed time and without delay, come what may! Our team ensures regular updates and tracking of deliveries, making the whole process as seamless as possible. </p>
                    <p>Our in-house consultations are sure to help you understand what it is that you need to eat, and in what quantity it is needed. Our kitchen is guaranteed to meet the HACCP kitchen safety standards, while giving you perfectly hot and tasty meals.</p>
                    <h3>Mission & Vision</h3>
                    <p>With an aim to ensure affordable diet options to our customers, our team is dedicated to getting all the right nutrients in your food box.</p>
<p>Healthy Food does not have to be expensive, and we are here to prove that to you! Our in-house and phone consultation services continue to help people choose their meal plans and set healthy goals. </p>
<p>We at Dietcare envision our customers leaving satisfied with our services and promoting the lifestyle to those that they meet. 
</p>
                </div>
            </div>
        </div>
    </section>
  )
}

export default DietCaresec2
